import { Injectable, Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Injectable({ providedIn: 'root' })
@Pipe({
	name: 'timezone'
})
export class TimezonePipe implements PipeTransform {
	transform(
		date: any,
		timezone: string,
		format: string,
		replace?: string
	): string {
		const momentDate = moment(date);

		return (
			!momentDate.isValid() ?
				replace ? replace
				:	'--'
			:	moment(date).tz(timezone).format(format)
		);
	}
}
